/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { EDIT_GROUP } from "./actionTypes"
import { apiError, editGroupSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updateGroup } from "../../../helpers/backend_helper"

function* edit(action) {
  try {
    const response = yield call(updateGroup, action.payload.form)
    yield put(editGroupSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* groupEditSaga() {
  yield takeEvery(EDIT_GROUP, edit)
}

export default groupEditSaga
